import { Listing } from '@app/models'

export const getListingById = (
  listings: Map<number, Listing>,
  id?: number
): Listing | null => {
  const result = id && listings.get(id) || null
  return result
}
